const invoiceProcessingJobsBasePath = '/invoice-processing-jobs';

export class InvoiceProcessingJobsPath {
  static index() {
    return invoiceProcessingJobsBasePath;
  }
}
